import React, { useContext, useRef, useEffect } from 'react';

import { CloseIcon } from '$partials/icon';
import { ModalContext } from '$contexts/modal.jsx';
import { useCursorContext } from '$contexts/cursor.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modals.d.ts').AmenitiesModal}
 */
const AmenitiesModal = ({
    amenities,
    description
}) => {
    const { handleModal } = useContext(ModalContext);
    const { dispatch: cursorDispatch } = useCursorContext();
    const exitButtonRef = useRef(null);

    useEffect(() => {
        const exit = cursorDispatch({
            type: 'registerArea',
            data: {
                ref: exitButtonRef,
                cursorType: 'exit'
            },
        });

        return () => [exit].map(cleanup => {
            cleanup();});
    }, []);

    return (
        <>
            <div
                className={'fixed left-0 top-0 height-100 width-100 border-0 m0 p0 overflow-hidden bg-black mix-blend-multiply z3 cursor-none'}
                onClick={() => handleModal()}
                ref={exitButtonRef}
                style={{opacity: '0.2'}}>
            </div>
            <div className='height-100 bg-white z4 fixed top-0 overflow-auto modal-container'>
                <button
                    aria-label='Close'
                    className='form-field-reset link-reset absolute right-0 right mt6 mr6 cursor-pointer'
                    onClick={() => handleModal()}
                    type='button'>
                    <CloseIcon/>
                </button>
                <div className='py7 px6'>
                    <h2 className='type-style-2'>Amenities</h2>
                    <div
                        className='col-9 mt5 mb7 type-style-6'
                        dangerouslySetInnerHTML={{__html: description}} />

                    <hr className='black'/>

                    {amenities?.map((amenity) => {
                        return (
                            <span key={amenity?.id}>
                                <p className='type-style-5 py6'>{amenity?.label}</p>
                                <hr className='black'/>
                            </span>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default AmenitiesModal ;
